export const LABELS = {
  title: 'Oops! Something went wrong.',
  buttonText: 'Try logging in again?',
  reloadButtonText: 'Reload the page',
  loadingFailedTitle: 'Kindly attempt to refresh the application, as it might be due to the most recent version.',
  loading: 'Loading...',
  noAssessmnetData: 'Please fill the assessment form to get the analysis.',
};
